"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _Background = _interopRequireDefault(require("./Background"));

var _JobLabel = _interopRequireDefault(require("./JobLabel"));

var _Salary = _interopRequireDefault(require("./Salary"));

var _SalaryChip = _interopRequireDefault(require("./SalaryChip"));

var _UpdateDate = _interopRequireDefault(require("./UpdateDate"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  return {
    background: {
      position: 'relative'
    },
    content: {
      zIndex: 1
    },
    chip: {
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translate(-50%, 50%)'
    }
  };
};

var Header = function Header(props) {
  var jobId = props.jobId,
      updateDate = props.updateDate,
      jobLabel = props.jobLabel,
      grossHourlyRate = props.grossHourlyRate,
      grossHourlyRateIncludingCP = props.grossHourlyRateIncludingCP,
      onSalaryClick = props.onSalaryClick,
      other = (0, _objectWithoutProperties2["default"])(props, ["jobId", "updateDate", "jobLabel", "grossHourlyRate", "grossHourlyRateIncludingCP", "onSalaryClick"]);
  var classes = useStyles();

  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    flex: 1,
    flexDirection: "column",
    alignItems: "center"
  }, other), (0, _core.jsx)(_Background["default"], {
    css: classes.background
  }, (0, _core.jsx)(_UpdateDate["default"], {
    date: updateDate
  }), (0, _core.jsx)(_JobLabel["default"], {
    css: /*#__PURE__*/(0, _css2["default"])({
      marginBottom: 0,
      marginTop: spacing(1)
    }, ";label:Header;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")),
    gutter: 3,
    jobLabel: jobLabel
  }), (0, _core.jsx)(_SalaryChip["default"], {
    css: classes.chip,
    onClick: onSalaryClick,
    grossHourlyRateIncludingCP: grossHourlyRateIncludingCP
  })), (0, _core.jsx)(_Flex["default"], {
    margin: [3, 0, 0],
    justifyContent: "center"
  }, (0, _core.jsx)(_Salary["default"], {
    grossHourlyRate: grossHourlyRate
  })));
};

__signature__(Header, "useStyles{classes}\nuseTheme{{ spacing }}", function () {
  return [useStyles, _useTheme2["default"]];
});

var _default = Header;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Header/index.tsx");
  reactHotLoader.register(Header, "Header", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Header/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Header/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();